





































import { Component, Vue } from 'vue-property-decorator'
import { TypeformAPI } from '@/api/client/typeform'
import { TypeformTheme } from '@/api/model/typeform/typeform-theme'
import { escapeHtml } from '@/helpers/html'

@Component
export default class CompanySettingsTypeformTheme extends Vue {
    theme: TypeformTheme = null
    loading: boolean = false
    saving: boolean = false

    async created() {
        await this.reload()
    }

    async reload() {
        this.loading = true
        this.theme = await TypeformAPI.getTheme()
        this.loading = false
    }

    async save() {
        this.saving = true
        try {
            this.theme = await TypeformAPI.updateTheme(this.theme)
        } catch (error) {
            this.$notify({
                group: 'validation',
                type: 'error',
                title: this.$t('error.title').toString(),
                text: this.$t('error.text', { message: escapeHtml(error.message) }).toString().replace(/\n/g, '<br>'),
            })
        } finally {
            this.saving = false
        }
    }
}
